<template>
  <div
    class="notification-toggle"
    id="notifDropdownMenu"
    role="menu"
    aria-labelledby="notification-center"
  >
    <div class="notification-panel" style="margin 0px !important; width: 100%;">
      <div
        class="notification-body scrollable"
        style="position: relative; min-height: 250px; overflow: auto !important"
      >
        <div v-if="is_loading" class="col-md-12">
          <loader-component
            :key="loading_key"
            :with_text="true"
            :text="loading_text"
          />
        </div>
        <div
          v-else-if="!is_loading && !data_notif"
          class="notif-content m-t-10"
        >
          <p align="center">Tidak ada pemberitahuan</p>
        </div>
        <div v-else class="notif-content">
          <div
            v-for="(notif, index) in data_notif"
            :key="'notif-' + index"
            @click="notifAction(index)"
            class="notification-item clearfix"
            :class="[{ unread: notif.read == 0 }]"
            style="cursor: pointer"
          >
            <div class="heading">
              <div class="row">
                <div class="col-md-1 p-r-0">
                  <div
                    class="thumbnail-wrapper d24 circular b-white m-r-5 b-a b-white m-t-10 m-r-10"
                  >
                    <i
                      :class="
                        icon_sources[notif.source.toLowerCase()] +
                        ' icon-' +
                        notif.source.toLowerCase()
                      "
                    />
                  </div>
                </div>
                <div class="col-md-11">
                  <a
                    href="javascript:void(0)"
                    style="
                      line-height: normal;
                      display: inline-flex;
                      width: 100%;
                    "
                  >
                    <span v-if="notif.type == 2" class="fs-12"
                      >Akun
                      <span class="bold text-blue">{{ notif.key }}</span>
                      mengunggah {{ notif.value }} posting baru</span
                    >
                    <span v-else class="fs-12"
                      >Kata
                      <span class="bold text-blue">{{ notif.key }}</span>
                      muncul pada {{ notif.value }} posting baru</span
                    >
                  </a>
                  <span
                    style="line-height: 20px; font-size: 10px"
                    class="pull-right time p-t-0"
                    >{{ notif.timestamp.$date | date_time_to_indo }}</span
                  >
                </div>
              </div>
            </div>
            <div
              class="option"
              data-toggle="tooltip"
              data-placement="left"
              title="mark as read"
            >
              <a href="#" class="mark" />
            </div>
          </div>
        </div>
      </div>
      <div class="notification-footer text-center">
        <a
          v-if="data_notif"
          href="javascript:void(0)"
          @click="deleteAll"
          class=""
          ><i class="bi bi-trash" /> Hapus semua</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import gp from "@/plugins/generalPlugins.js";
import loader_component from "@/views/components/loader.vue";

var icon_sources = [];
icon_sources["google"] = "bi bi-google";
icon_sources["facebook"] = "bi bi-facebook";
icon_sources["twitter"] = "bi bi-twitter";
icon_sources["instagram"] = "bi bi-instagram";
icon_sources["youtube"] = "bi bi-youtube";
icon_sources["news"] = "bi bi-globe-americas";
icon_sources["blog"] = "bi bi-rss";
icon_sources["forum"] = "bi bi-chat-dots-fill";
export default {
  name: "header_notification",
  components: {
    "loader-component": loader_component,
  },
  data() {
    return {
      data_notif: null,
      is_loading: true,
      loading_key: 0,
      loading_text: "Memuat pemberitahuan",
      icon_sources: icon_sources,
      id_project: this.$store.getters.user.id_project,
    };
  },
  methods: {
    getData: function () {
      let api =
        process.env.VUE_APP_API_URL + "all-notifications/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.data_notif = response.data;
          } else {
            this.data_notif = null;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    notifAction: function (index) {
      $("#modalSlideUp").modal("hide");
      $(event.target).closest(".notification-item").removeClass("unread");
      let api = process.env.VUE_APP_API_URL + "read-notifications";
      let param_notif = {
        _id: this.data_notif[index]._id.$oid,
      };
      this.$http.post(api, param_notif);
      $(".dropdown-menu").slideUp("fast");
      $("#notifDropdownMenu").removeAttr("style");
      let notif = this.data_notif[index];
      let params = {
        q: notif.key,
      };
      this.$router.push({ path: "/posts", query: params });
    },
    deleteAll: function () {
      let api = process.env.VUE_APP_API_URL + "delete-all-notifications";
      let param = {
        id_project: this.id_project,
      };
      this.is_loading = true;
      this.loading_text = "Menghapus pemberitahuan";
      this.loading_key++;

      this.$http
        .post(api, param)
        .then((response) => {
          if (response.status == 200) {
            this.loading_text = "Pemberitahuan berhasil dihapus.";
            this.loading_key++;
          }
        })
        .catch((error) => {
          this.loading_text = "Terjadi kesalahan" + error.response.status;
          this.loading_key++;
        })
        .finally(() => {
          this.is_loading = false;
          this.getData();
        });
    },
  },
  filters: {
    date_time_to_indo: function (tanggal) {
      return gp.dateTimeID(tanggal);
    },
  },
  created: function () {
    this.getData();
  },
};
</script>

<style scoped>
.notif-content .unread {
  background-color: #17a2b8;
}
</style>